/**
 * Factory file for project history related data (single page).
 *
 * @exports projectHistoryItems
 * @category Factories
 */
export default {
  /**
   * Get projectHistory Item
   *
   * @param {object} initialData
   * @returns {object}
   */
  getProjectHistoryItem: (initialData = {}) => ({
    after_value: '45.6',
    attributable_type: 'RateAttribute',
    before_value: '12.3',
    carrier_name: 'Unum',
    created_at: '2019-10-21T21:19:37.519162',
    first_created_at: null,
    history_details: {
      attribute_name: 'Eligibility Hours',
      container_name: 'Plan',
      container_type: 'Plan',
      rate_values: [],
      tier_subtype_name: 'Non-Smoker',
      responsible_user: {
        broker: {},
        carrier: {
          name: 'Unum',
          ...initialData.carrier,
        },
        first_name: 'Bob',
        id: 1,
        last_name: 'Smith',
        ...initialData.responsible_user,
      },
      ...initialData.history_details,
    },
    is_new: false,
    last_created_at: '2019-10-21T21:12:09.150978',
    product_type_name: 'Dental',
    project_product_label: 'Dental',
    updated_at: '2019-10-21T21:19:37.519162',
    ...initialData.root,
  }),

  /**
   * Get projectHistoryDates
   *
   * @param {object} initialData
   * @param {number} numberOfItems
   * @returns {object}
   */
  getProjectHistoryItems(initialData = {}, numberOfItems = 1) {
    return [...Array(numberOfItems)].map(() => this.getProjectHistoryItem(initialData));
  },

  /**
   * Get projectHistoryDates
   *
   * @param {Array} initialData
   * @returns {object}
   */
  getProjectHistoryDates(initialData = []) {
    const dates = [
      this.getProjectHistoryItems(initialData, 10),
      this.getProjectHistoryItems(initialData, 3),
    ];
    return dates;
  },
};
